import { Editor } from 'slate'

const MaterialEditor = {
    ...Editor,
}

export default MaterialEditor